import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import HomeDefault from '../../../../components/HomeDefaultComponent';
import { translate } from '../../../../utils/util';
import { PERMISSIONS } from '../../../../utils/constants';
import { checkPermission } from '../../../../services/auth';
import * as actionLinePicking from '../../../../actions/linePickingAction';

const Home = (props) => {
    const menu = () => {
        let menuItems = [];

        menuItems = [...menuItems,

        {
            onClick: () => {
                props.setMapping({});
            }, route: 'mapping/insert', icon: 'mdi mdi-plus-box-outline', text: translate('mapping:insert', 'line-picking')
        }];

        menuItems = [...menuItems, {
            route: {
                pathname: 'mapping/list',
                state: { quantityAlignment: false }
            }, icon: 'mdi mdi-clipboard-list-outline', text: translate('mapping:list', 'line-picking')
        }];

        if (checkPermission(PERMISSIONS.LinePicking.Mapping.Registrations)) {

            menuItems = [...menuItems, { route: 'mapping/registration', icon: 'mdi mdi-clipboard-list-outline', text: translate('deemsqp:menu.registrations') }];
        }



        return menuItems;
    };

    return (
        <HomeDefault menu={menu()} title={{ icon: "mdi mdi-grid", label: translate('mapping:title', 'line-picking') }} sub />
    );
};


const mapStateToProps = () => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setMapping: (item) => {
            dispatch(actionLinePicking.setMapping(item));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
